
// export const api = "https://tmm-backend-api.herokuapp.com/api/v1/";
// export const api = "http://localhost:4000/api/v1/";
// export const api = "http://localhost:4000/api/v1";
// export const api = "https://tmm.api.colourbangladev.xyz/api/v1/"
// export const api = "https://api.biyesadi.com/backend/api/v1/";

// export const api = `${process.env.REACT_APP_API_URL}/api/v1/admin/`;
export const api = `${process.env.REACT_APP_API_URL}/api/v1/admin/`;
export const apiPremium = `${process.env.REACT_APP_API_URL}/api/v1/`;